// 合规审计弹窗
import { useEffect, useState } from 'react';

import { deSensitive } from '@lcsc-design/utils/sensitive';
import CusServicePop from '@lcsc-ui/components/ToolBar/components/CusServicePop';
import Domains from '@lcsc-ui/utils/domains';
import lcMsgTips from '@lcsc-ui/utils/lcMsgTips';
import sendAxios from '@lcsc-ui/utils/request';
import { Modal, Alert, Button, message, Popover } from 'antd';
import { cloneDeep } from 'lodash-es';
import styled from 'styled-components';

const Main = styled.section`
  * {
    box-sizing: border-box;
  }
  .b {
    font-weight: bold;
  }

  .audit-content {
    background-color: #fff;
  }

  .audit-top {
    width: 100%;
    padding: 20px;
  }
  .audit-top .a1 {
    font-size: 18px;
  }
  .audit-top .wx {
    width: 30px;
    height: 31px;
    background-image: url(//static.szlcsc.com/ecp/assets/web/layout/tools/images/wx.svg);
    background-repeat: no-repeat;
    background-position: center;
  }
  .audit-top .kf {
    width: 30px;
    height: 31px;
    background-image: url(//static.szlcsc.com/ecp/assets/web/layout/tools/images/kf.svg);
    background-repeat: no-repeat;
    background-position: center;
  }

  .audit-tip {
    background-color: #fde7cb;
    padding: 20px;
    border-top: #999;
  }

  .audit-conf {
    padding: 0 20px;
  }
  .audit-conf .k {
    padding: 20px 0;
  }

  .audit-content {
    padding: 10px 20px;
    border-bottom: 1px solid #1abc9c;
  }
  .audit-content .audit-main {
    width: 100%;
    overflow: auto;
    height: 400px;
    padding-left: 30px;
    padding-right: 80px;
  }
  .audit-content .audit-main .audit-item {
    margin-top: 20px;
  }
  .audit-content .audit-main .audit-item .audit-item-top {
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .audit-content .audit-main .audit-item .audit-item-top.ix {
    color: #7f7fa8;
  }

  .audit-content .audit-main .audit-item .audit-item-top .ad1 {
    display: flex;
    align-items: center;
    padding-left: 30px;
  }

  .audit-content .audit-main .audit-item .audit-item-content {
    padding-left: 40px;

    label {
      margin-top: 20px;
      margin-right: 30px;
    }

    .whenOther {
      margin-top: 20px;
      transform: translateY(-3px);
      position: relative;

      input {
        &.err {
          border-color: red;
        }
      }

      .errText {
        font-size: 12px;
        color: red;
        position: absolute;
        left: 0;
        top: 110%;
      }
    }

    table {
      margin-top: 10px;
      border-top: 1px solid #d7d7d7;
      border-left: 1px solid #d7d7d7;

      th,
      td {
        text-align: center;
        padding: 8px 0;
        border-right: 1px solid #d7d7d7;
        border-bottom: 1px solid #d7d7d7;
      }
      th {
        background: #f2f2f2;
      }
    }

    .p1 {
      font-size: 14px;
      font-weight: bold;
      display: flex;
      align-items: center;
      line-height: 14px;
      margin-top: 10px;
    }
  }

  .audit-bottom {
    padding: 20px;
    border-top: 1px solid #d7d7d7;
    font-size: 14px;
  }
  .audit-bottom .audit-bottom-btn {
    padding: 5px 10px;
    font-size: 16px;
    border: 1px solid #0000ff;
    color: #0000ff;
    cursor: pointer;
    border-radius: 2px;
    background-color: #fff;

    &.s {
      border-color: #7f7f7f;
      color: #7f7f7f;
    }
  }
  .audit-bottom .audit-bottom-btn + .audit-bottom-btn {
    margin-left: 15px;
  }

  .gray {
    padding: 5px;
    background-color: #f2f2f2;
    border-radius: 2px;
    margin: 0 5px;
    color: #000;
  }

  .line {
    background-image: linear-gradient(to right, #1abc9c 60%, #fff 0%);
    background-position: bottom;
    background-size: 20px 1px;
    background-repeat: repeat-x;
    height: 1px;
    width: 100%;
  }

  .auditSuccess {
    width: 400px;
    background-color: #fff;
    border-radius: 5px;

    .audit-success-top {
      padding: 20px;
      display: flex;
      justify-content: flex-end;
    }
    .audit-success-content {
      width: 100%;
      height: 300px;
      display: flex;
      align-items: center;
      flex-direction: column;
      img {
        width: 50px;
        margin-top: 55px;
      }
      .s1 {
        font-size: 14px;
        font-weight: bold;
        margin: 15px 0;
      }
      .s2 {
        font-size: 14px;
      }
    }
  }
`;

const radioList = {
  person: ['员工', '法定代表人', '实际控制人', '股东', '法定代表人/实际控制人/股东亲戚', '其他'],
  enterprise: ['子母公司', '相同老板', '合作关系', '其他'],
  other: [
    '员工',
    '法定代表人',
    '实际控制人',
    '股东',
    '法定代表人/实际控制人/股东亲戚',
    '子母公司',
    '相同老板',
    '合作关系',
    '其他',
  ],
};

const MainContent = ({ currentData, onBlur, onChange, onInputChange }) => {
  if (!currentData.waitConfirmList || currentData.waitConfirmList.length === 0) {
    return <></>;
  } else {
    return (
      <section className="audit-main">
        {currentData.waitConfirmList.map((v, i) => {
          return (
            <section key={v.uuid}>
              {v.payerType === 'person' && (
                <div className="audit-item">
                  <div className="audit-item-top">
                    <span className="ix">{i + 1}</span>
                    <p className="ad1">
                      <span className="gray">{v.payer}</span>与
                      <span className="gray">
                        {/* <Sensitive orginalText={currentData.companyName}></Sensitive> */}
                        <span>{currentData.companyName}</span>
                      </span>
                      的关系是：
                    </p>
                  </div>
                  <div className="audit-item-content">
                    <div className="flex flex-wrap">
                      {radioList[v.payerType].map((item, idx) => {
                        return (
                          <label key={idx}>
                            <input
                              type="radio"
                              className="mr-[2px]"
                              checked={item === v.relation}
                              name={v.uuid}
                              value={item}
                              onChange={() => onChange(i, item)}
                            />
                            {item}
                          </label>
                        );
                      })}
                      {v.relation === '其他' && (
                        <div className="whenOther">
                          <input
                            className={`${v.errorText ? 'err' : ''} border border-solid border-[#dedede]`}
                            type="text"
                            value={v.relationText}
                            onChange={(e) => onInputChange(i, e.target.value)}
                            onBlur={() => onBlur(i)}
                            maxLength="20"
                          />
                          {v.errorText && <span className="errText">{v.errorText}</span>}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {v.payerType === 'enterprise' && (
                <div className="audit-item">
                  <div className="audit-item-top">
                    <span className="ix">{i + 1}</span>
                    <p className="ad1">
                      <span className="gray">{v.payer}</span>与
                      <span className="gray">
                        {/* <Sensitive orginalText={currentData.companyName}></Sensitive> */}
                        <span>{currentData.companyName}</span>
                      </span>
                      的关系是：
                    </p>
                  </div>
                  <div className="audit-item-content">
                    <div className="flex flex-wrap">
                      {radioList[v.payerType].map((item, idx) => {
                        return (
                          <label key={idx}>
                            <input
                              type="radio"
                              checked={item === v.relation}
                              name={v.uuid}
                              value={item}
                              onChange={() => onChange(i, item)}
                            />
                            {item}
                          </label>
                        );
                      })}
                      {v.relation === '其他' && (
                        <div className="whenOther">
                          <input
                            className={`${v.errorText ? 'err' : ''} border border-solid border-[#dedede]`}
                            type="text"
                            value={v.relationText}
                            onChange={(e) => onInputChange(i, e.target.value)}
                            onBlur={() => onBlur(i)}
                            maxLength="20"
                          />
                          {v.errorText && <span className="errText">{v.errorText}</span>}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {v.payerType === 'other' && (
                <div className="audit-item">
                  <div className="audit-item-top">
                    <span className="ix">{i + 1}</span>
                    <p className="ad1">
                      订单支付方式为：
                      <span className="gray flex items-center">
                        {v.payChannel === '微信' && (
                          <img src="//static.szlcsc.com/ecp/assets/web/layout/auditPop/images/wx.png" width="18" />
                        )}
                        {v.payChannel === '支付宝' && (
                          <img src="//static.szlcsc.com/ecp/assets/web/layout/auditPop/images/zfb.png" width="18" />
                        )}
                        <span className="ml-[5px]"> {v.payChannel}</span>
                      </span>
                      ，共{v.payerCount}个不同的付款人，其中第{v.number}个付款人，最近{v.transactionFlowList.length}
                      笔支付明细如下：
                    </p>
                  </div>
                  <div className="audit-item-content">
                    <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                      <thead>
                        <tr>
                          <th>序号</th>
                          <th>支付时间</th>
                          <th>支付金额</th>
                          <th>支付用途</th>
                        </tr>
                      </thead>
                      <tbody>
                        {v.transactionFlowList.map((item, idx) => {
                          return (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              <td>{item.paymentTime}</td>
                              <td>{item.payAmount}元</td>
                              <td>{item.payPurpose}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <p className="p1">
                      这{v.transactionFlowList.length}笔支付记录的付款人与
                      <span className="gray">
                        {/* <Sensitive orginalText={currentData.companyName}></Sensitive> */}
                        <span>{currentData.companyName}</span>
                      </span>
                      的关系是：
                    </p>
                    <div className="flex flex-wrap">
                      {radioList[v.payerType].map((item, idx) => {
                        return (
                          <label key={idx}>
                            <input
                              type="radio"
                              checked={item === v.relation}
                              name={v.uuid}
                              value={item}
                              onChange={() => onChange(i, item)}
                            />
                            {item}
                          </label>
                        );
                      })}
                      {v.relation === '其他' && (
                        <div className="whenOther">
                          <input
                            className={`${v.errorText ? 'err' : ''} border border-solid border-[#dedede]`}
                            type="text"
                            value={v.relationText}
                            onChange={(e) => onInputChange(i, e.target.value)}
                            onBlur={() => onBlur(i)}
                            maxLength="20"
                          />
                          {v.errorText && <span className="errText">{v.errorText}</span>}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </section>
          );
        })}
      </section>
    );
  }
};

const AuditFooter = ({ invData, currentIndex, setCurrentIndex, submitForm, dialogType }) => {
  if (invData) {
    const next = () => {
      setCurrentIndex(currentIndex + 1);
    };
    const pvre = () => {
      setCurrentIndex(currentIndex - 1);
    };

    return (
      <section className="flex justify-between">
        <span>
          共{invData.length}个订单主体需确认，订单主体位置 {currentIndex + 1}/{invData.length}
        </span>
        <section>
          {currentIndex > 0 && invData.length > 1 && <Button onClick={pvre}>上一个主体</Button>}
          {currentIndex + 1 !== invData.length && invData.length > 1 && (
            <Button className="ml-[10px]" type="primary" onClick={next}>
              下一个主体
            </Button>
          )}
          {currentIndex + 1 === invData.length && (
            <Button onClick={submitForm} className="ml-[10px]" type="primary">
              {dialogType === 'AuditBoxAndConfirmBox' ? '提交，并下一步' : '提交'}
            </Button>
          )}
        </section>
      </section>
    );
  } else {
    return <></>;
  }
};

const AuditHeader = () => {
  return (
    <section className="flex justify-between pr-[30px]">
      <span>合规审计要求</span>
      <section className="flex relative top-[-3px]">
        <span className="font-normal text-[12px]">联系客服：</span>
        <Popover content={<CusServicePop />} placement="leftTop" overlayInnerStyle={{ padding: 0 }}>
          <img
            className="size-[25px] cursor-pointer relative top-[-2px]"
            src="//static.szlcsc.com/ecp/assets/web/layout/tools/images/kf.svg"
            alt="wx"
          />
        </Popover>
      </section>
    </section>
  );
};

const AuditBox = ({ show, setShow, dialogType, setDialogType, confirmBelongClose }) => {
  const [invData, setInvData] = useState(null);
  const [currentData, setCurrentData] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // function todayNotShow() {
  //   // 当天不再弹出
  //   sendAxios({
  //     method: 'post',
  //     url: `/member/invoice/payer/confirm`,
  //     baseURL: Domains.lcscWwwUrl,
  //   });
  // }

  useEffect(() => {
    initDialog();
    // todayNotShow();
  }, []);

  useEffect(() => {
    if (invData) {
      setCurrentData(invData[currentIndex]);
    }
  }, [currentIndex]);

  function initDialog() {
    sendAxios({
      method: 'get',
      url: `/member/invoice/payer/init`,
      baseURL: Domains.lcscWwwUrl,
    }).then(async (res) => {
      if (res.code === 200) {
        const invData = [];
        for await (const v of res.result) {
          v.companyName = await deSensitive(v.companyName);
          v.taxNumber = await deSensitive(v.taxNumber);
          if (Array.isArray(v.waitConfirmList)) {
            for await (const item of v.waitConfirmList) {
              item.relation = '';
              item.relationText = '';
              item.errorText = '';
              item.cardNo = await deSensitive(item.cardNo);
              item.payer = await deSensitive(item.payer);
              if (Array.isArray(item.transactionFlowList)) {
                for await (const x of item.transactionFlowList) {
                  x.cardNo = await deSensitive(x.cardNo);
                  x.taxNumber = await deSensitive(x.taxNumber);
                }
              }
            }
          }
          invData.push(v);
        }
        setInvData(invData);
        setCurrentData(invData[currentIndex]);
      } else {
        setShow(false);
      }
    });
  }

  function closeModal() {
    setShow(false);
    setDialogType(null);
  }

  function handleCancel() {
    if (dialogType === 'AuditBoxAndConfirmBox') {
      confirmBelongClose();
    }
    sendAxios({
      method: 'post',
      url: '/member/invoice/payer/close',
      baseURL: Domains.lcscWwwUrl,
    });
    setShow(false);
  }

  const updateCurrentData = (i, type, val) => {
    setCurrentData((draft) => {
      const pre = cloneDeep(draft);
      const item = pre.waitConfirmList[i];
      if (item) {
        item[type] = val;
      }
      return pre;
    });
  };
  const updateInvData = (i, waitConfirmListIdx, type, val) => {
    setInvData((draft) => {
      const pre = cloneDeep(draft);
      const item = pre[i].waitConfirmList[waitConfirmListIdx];
      if (item) {
        item[type] = val;
      }
      return pre;
    });
  };

  function onBlur(i) {
    const { relationText } = currentData.waitConfirmList[i];
    let errorText = '';
    if (!relationText) {
      errorText = '请输入关系';
    } else if (!/^[\u4e00-\u9fa5]+$/.test(relationText)) {
      errorText = '请输入有效的内容';
    }
    updateCurrentData(i, 'errorText', errorText);
    updateInvData(currentIndex, i, 'errorText', errorText);
  }

  function onChange(i, relation) {
    updateCurrentData(i, 'relation', relation);
    updateInvData(currentIndex, i, 'relation', relation);
    if (relation !== '其他') {
      // 清除错误提示
      updateCurrentData(i, 'errorText', '');
      updateCurrentData(i, 'relationText', '');
      updateInvData(currentIndex, i, 'errorText', '');
      updateInvData(currentIndex, i, 'relationText', '');
    }
  }
  function onInputChange(i, relationText) {
    updateCurrentData(i, 'relationText', relationText);
    updateInvData(currentIndex, i, 'relationText', relationText);
  }

  function submitForm() {
    const confirmList = invData.map((v) => {
      const data = {};
      data.taxNumber = v.taxNumber;
      data.invoicePayerRelationList = v.waitConfirmList.map((item) => {
        const waitItem = {};
        waitItem.uuid = item.uuid;

        if (item.relation === '其他') {
          // 当为其他时，判断一下是否有错误提示，有就代表没校验过
          waitItem.relation = item.errorText ? '' : item.relationText;
        } else {
          waitItem.relation = item.relation;
        }

        return waitItem;
      });
      return data;
    });
    // 是否需要提示继续输入
    const needContinue = confirmList.some((v) => {
      return v.invoicePayerRelationList.some((item) => !item.relation);
    });

    if (needContinue) {
      lcMsgTips.showConfirmModal({
        title: '无法提交',
        message: '您尚未确认完所有付款人与订单主体关系',
      });
    } else {
      sendAxios({
        method: 'post',
        url: `/member/invoice/payer/submit`,
        baseURL: Domains.lcscWwwUrl,
        data: { confirmList },
      }).then(async (res) => {
        if (res.code === 200) {
          if (dialogType === 'AuditBoxAndConfirmBox') {
            // 继续弹窗
            setDialogType('ConfirmBelongBox');
          } else {
            message.success('提交成功，感谢您的支持与配合！');
            closeModal();
          }
        }
      });
    }
  }

  return (
    <Modal
      title={<AuditHeader />}
      centered
      maskClosable={false}
      width={1000}
      open={show}
      onCancel={handleCancel}
      footer={
        <AuditFooter
          dialogType={dialogType}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          invData={invData}
          submitForm={submitForm}
        />
      }
    >
      <Alert
        type="info"
        banner
        message="根据数据安全与合规审计要求，需要您完善以下订单付款人与订单主体的关系。请您务必准确填写以下信息，谢谢您的支持与配合！"
      ></Alert>
      {!currentData ? (
        <p>数据获取中...</p>
      ) : (
        <Main>
          <section className="audit-content">
            <p className="my-[20px]">
              请确认，以下<b>&nbsp;付款人&nbsp;</b>与&nbsp;
              <b>
                订单主体：
                {currentData.companyName}
                {/* <Sensitive orginalText={currentData.companyName}></Sensitive> */}
              </b>
              &nbsp;关系
            </p>
            <section className="line"></section>
            <MainContent currentData={currentData} onBlur={onBlur} onInputChange={onInputChange} onChange={onChange} />
          </section>
        </Main>
      )}
    </Modal>
  );
};

export default AuditBox;
